<div class="timeline">
	<ul class="container timeline__steps-wrapper">
		<li *ngFor="let step of timelineSteps" class="timeline__step" [ngClass]="step.class">
			<div class="timeline__description" *ngIf="step.description">
				<span skeletonLoader [translationKey]="step.descriptionSuffix">
					{{step.descriptionCount}} {{step.descriptionSuffix | ibeadmin | async}}
				</span>
			</div>
			<app-svg *ngIf="step.class === 'timeline__step--flight' && !step.multipleAirlinesFlag"
				class="timeline__logo" 
				svg={{step.logo}} 
				[tooltip]="step.tooltip">
			</app-svg>
			<app-svg *ngIf="step.class === 'timeline__step--flight' && step.multipleAirlinesFlag" 
				class="timeline__logo" 
				svg={{step.logo}} 
				[tooltip]="'bookingDetails.label.multipleAirlines' | ibeadmin | async">
			</app-svg>
			<app-svg *ngIf="step.class === 'timeline__step--stopover'
				"class="timeline__logo" svg={{step.logo}} 
				tooltip="{{'bookingDetails.label.stopoverIn' | ibeadmin | async}} {{step.tooltip}}">
			</app-svg>
			<div class="timeline__line"></div>
			<div class="timeline__label">
				<span
					*ngIf="step.label.toLowerCase() == 'lisbon'; else cityTemplate"
					skeletonLoader
					[translationKey]="'extrasSidebar.text.countryLisbon'"
				>
					{{ 'extrasSidebar.text.countryLisbon' | ibeadmin | async }}
				</span>
				<ng-template #cityTemplate>
					{{ step.label }}
				</ng-template>
			</div>
			<div class="timeline__date">{{step.date}}</div>
		</li>
	</ul>
</div>
